import App from '@/models/App'

export default class OrderingOrdererItemImage extends App {
    static get entity() {
        return 'OrderingOrdererItemImages'
    }

    static all() {
        return this.query().get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingItemId: this.attr(''),
            path: this.attr(''),
            thumbnailPath: this.attr(''),
            order: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            create(orderingShipId, orderingItemId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/items/${orderingItemId}/images`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(
                orderingShipId,
                orderingItemId,
                orderingItemImageId,
                params
            ) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/items/${orderingItemId}/images/${orderingItemImageId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingItemId, orderingItemImageId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/items/${orderingItemId}/images/${orderingItemImageId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingItemImageId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
